import { observer } from 'mobx-react-lite'
import { type FC, useEffect } from 'react'
import classnames from 'classnames'
import { Scrollbar, Tabs } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { type ResultsStore } from 'pages/conversations/pages/search/ui/Results'
import { SectionContacts } from 'pages/conversations/pages/search/ui/Results/ui/SectionContacts'
import { SectionMessages } from 'pages/conversations/pages/search/ui/Results/ui/SectionMessages'
import {
  ProviderResults,
  useResultsContext,
} from 'pages/conversations/pages/search/ui/Results/context/resultsContext'
import { SectionAllContacts } from 'pages/conversations/pages/search/ui/Results/ui/SectionAllContacts'
import { SectionAllMessages } from 'pages/conversations/pages/search/ui/Results/ui/SectionAllMessages'
import { logV2SearchEvent } from 'pages/conversations/pages/search/utils/logSearchEvent'
import { useConversationsPageLayoutContext } from 'pages/conversations/context/conversationsPageLayoutContext'
import styles from './styles.module.scss'

export const ResultsContent = observer(() => {
  const { tabs, activeTab, setActiveTab, presetActiveTab, loadingCreating, setVisibleUI } =
    useResultsContext()
  const entities = useEntitiesContext()
  const { pageLayoutStore } = useConversationsPageLayoutContext()

  useEffect(() => {
    presetActiveTab()
    setVisibleUI(true)

    return () => {
      setVisibleUI(false)
    }
  }, [])

  const renderContent = () => {
    if (activeTab === 'top_results') {
      return (
        <Scrollbar indentX={20}>
          <SectionContacts />
          <SectionMessages />
        </Scrollbar>
      )
    }

    if (activeTab === 'contacts') {
      return <SectionAllContacts />
    }

    if (activeTab === 'messages') {
      return <SectionAllMessages />
    }
  }

  return (
    <div
      className={classnames(styles.wrap, {
        [styles.loadingCreating]: loadingCreating,
        [styles['wrap--collapse']]: pageLayoutStore.isCollapse,
      })}
    >
      <div className={styles.tabs}>
        <Tabs
          tabs={tabs}
          activeTabKey={activeTab}
          variant={'dividerForFirst'}
          handleSelectTab={(tab) => {
            setActiveTab(tab.key)

            if (tab.key === 'messages') {
              logV2SearchEvent(
                'Search Page Result Clicked',
                {
                  event_id: 'search_page_result_clicked',
                  SearchResultClickedType: 'Messages tab',
                },
                entities
              )
            }

            if (tab.key === 'contacts') {
              logV2SearchEvent(
                'Search Page Result Clicked',
                {
                  event_id: 'search_page_result_clicked',
                  SearchResultClickedType: 'Contacts tab',
                },
                entities
              )
            }
          }}
        />
      </div>

      {renderContent()}
    </div>
  )
})

type IResultsProps = {
  store: ResultsStore
}

export const Results: FC<IResultsProps> = observer(({ store }) => {
  return (
    <ProviderResults value={store}>
      <ResultsContent />
    </ProviderResults>
  )
})
